"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.375 0h-33.75A5.625 5.625 0 008 5.625V60l22.5-13.125L53 60V5.625A5.625 5.625 0 0047.375 0z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.25 53.471L30.5 42.534 11.75 53.47V5.625c0-1.034.841-1.875 1.875-1.875h33.75c1.034 0 1.875.841 1.875 1.875v47.846z",
    fill: "#FFF",
    opacity: 0.88
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.375 0A5.625 5.625 0 0153 5.625V60L30.5 46.875 8 60V5.625A5.625 5.625 0 0113.625 0h33.75zm1.875 53.471V5.625a1.877 1.877 0 00-1.875-1.875h-33.75a1.877 1.877 0 00-1.875 1.875v47.846L30.5 42.534 49.25 53.47z",
    fill: "currentColor"
  })));
};
var _default = exports.default = SvgBookmark;